import {
  SearchbarCom,
  SidenavbarCom,
  FileUpload,
  Text,
} from "../../components";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import Modal from "react-modal";
import Cropper from "react-easy-crop";
import { fontSizes } from "../../constants/constants";
import Functions from "./index.function.js";
import { IoClose } from "react-icons/io5";

Modal.setAppElement("#root");

export default function TalentGallery() {
  const {
    TextWeight,
    loading,
    talentData,
    galleryImages,
    isOpen,
    selectedIndex,
    isError, // ✅ Add error state
    error,   // ✅ Add error object
    submittedCount,
    // Cropper (only for hero and banner)
    cropperOpen,
    cropperType,
    imageToCrop,
    crop,
    zoom,
    setCrop,
    setZoom,
    onCropComplete,
    handleCropSave,
    handleCropCancel,
    getCropperAspectRatio,
    getCropperTitle,
    
    // Hero image
    selectedHeroImage,
    handleHeroImageSelect,
    handleHeroImageUpload,
    removeSelectedHeroImage,
    
    // Banner image
    selectedBannerImage,
    handleBannerImageSelect,
    handleBannerImageUpload,
    removeSelectedBannerImage,
    talentBanner,
    
    // Gallery images (no cropper)
    selectedGalleryImages,
    handleGalleryImagesSelect,
    handleGalleryImagesUpload,
    removeSelectedGalleryImage,
    handleDeleteGalleryImage,
    
    openGallery,
    closeGallery,
    navigate,
    localimgpath,
  } = Functions();

  // Handle error state
  if (isError) {
    return (
      <div className="sm:h-screen w-screen flex flex-col bg-[#000000]">
        <SearchbarCom />
        <div className="grid sm:grid-cols-7 lg:grid-cols-6 xs:pt-10 sm:pt-16 sm:px-2 lg:px-2 xl:px-3">
          <div className="sm:col-span-2 lg:col-span-1 xs:z-50">
            <SidenavbarCom />
          </div>
          <div className="sm:col-span-5 flex items-center justify-center">
            <div className="text-center p-8">
              <p className="text-red-500 text-xl mb-4">Error loading gallery</p>
              <p className="text-gray-400">{error?.message || "Unknown error occurred"}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="sm:h-screen w-screen flex flex-col bg-[#000000]">
      {/* Navbar */}
      <SearchbarCom />
      
      <div className="grid sm:grid-cols-7 lg:grid-cols-6 xs:pt-10 sm:pt-16 sm:px-2 lg:px-2 xl:px-3">
        {/* Left Sidebar */}
        <div className="sm:col-span-2 lg:col-span-1 xs:z-50">
          <SidenavbarCom />
        </div>

        {/* Center Content (Scrollable) */}
        <div className="sm:col-span-5 scroll-container h-[calc(100vh-4rem)]">
          <div className="w-full xs:px-1 sm:pl-4 lg:pl-5 pt-2 pb-1 h-full">
            <div className="w-full h-full bg-[#1A1A1A] xs:px-2 sm:px-3 lg:px-5 rounded-lg">
              <div className="flex flex-col overflow-y-auto scroll-container relative w-full h-full xs:pt-2 sm:py-3 lg:py-5">
                
                {/* === HERO IMAGE SECTION === */}
                <div className="mb-6">
                  <FileUpload
                    text={"Select Display Profile Image (4:4) - Max 2MB"}
                    className={"mb-4"}
                    handleChange={handleHeroImageSelect}
                    loading={loading.HeroImage}
                  />
                  
                  {/* Preview selected image */}
                  {selectedHeroImage && (
                    <div className="mb-4">
                      <div className="relative inline-block">
                        <img
                          src={selectedHeroImage.preview}
                          className="w-[215px] h-[285px] object-cover rounded-xl"
                          alt="Selected hero"
                        />
                        <button
                          onClick={removeSelectedHeroImage}
                          className="absolute top-2 right-2 bg-red-600 text-white rounded-full p-2 hover:bg-red-700"
                        >
                          <IoClose size={20} />
                        </button>
                      </div>
                      
                      {/* Update button */}
                      <button
                        onClick={handleHeroImageUpload}
                        disabled={loading.HeroImage}
                        className="mt-4 px-6 py-3 bg-gradient-to-r from-[#D4AF37] to-[#F4D03F] text-black font-semibold rounded-full hover:scale-105 transition-transform disabled:opacity-50"
                      >
                        {loading.HeroImage ? "Uploading..." : "Update Profile Image"}
                      </button>
                    </div>
                  )}
                  
                  {/* Current hero image */}
                  {!selectedHeroImage && talentData?.hero_image && (
                    <div className="mb-4">
                      <p className="text-gray-400 mb-2 text-[#fff]">Current Profile Image:</p>
                      <img
                        src={`${localimgpath?.talentThumbnail}/${talentData?.hero_image}`}
                        className="w-64 h-64 object-cover rounded-xl"
                        alt={talentData?.real_name}
                      />
                    </div>
                  )}
                  
                  {!selectedHeroImage && !talentData?.hero_image && (
                    <Text
                      text={"No Profile Image"}
                      color="text-secondary"
                      size={fontSizes.h20}
                      isCenter={true}
                      isTruncate={false}
                      weight={TextWeight.Onest_regular}
                    />
                  )}
                </div>

                {/* === BANNER IMAGE SECTION === */}
                <div className="mb-6">
                  <FileUpload
                    text={"Select Banner Image (32:10) - Max 2MB"}
                    className={"mb-4"}
                    handleChange={handleBannerImageSelect}
                    loading={loading.BannerImage}
                  />
                  
                  {/* Preview selected image */}
                  {selectedBannerImage && (
                    <div className="mb-4">
                      <div className="relative inline-block w-full">
                        <img
                          src={selectedBannerImage.preview}
                          className="w-full max-w-2xl h-56 object-cover rounded-xl"
                          alt="Selected banner"
                        />
                        <button
                          onClick={removeSelectedBannerImage}
                          className="absolute top-2 right-2 bg-red-600 text-white rounded-full p-2 hover:bg-red-700"
                        >
                          <IoClose size={20} />
                        </button>
                      </div>
                      
                      {/* Update button */}
                      <button
                        onClick={handleBannerImageUpload}
                        disabled={loading.BannerImage}
                        className="mt-4 px-6 py-3 bg-gradient-to-r from-[#D4AF37] to-[#F4D03F] text-black font-semibold rounded-full hover:scale-105 transition-transform disabled:opacity-50"
                      >
                        {loading.BannerImage ? "Uploading..." : "Update Banner Image"}
                      </button>
                    </div>
                  )}
                  
                  {/* Current banner image */}
                  {!selectedBannerImage && talentData?.banner && (
                    <div className="mb-4">
                      <p className="text-gray-400 mb-2 text-[#fff]">Current Banner:</p>
                      <img
                        key={talentBanner || talentData?.banner} // forces re-render when banner changes
                        src={
                          talentBanner
                            ? talentBanner
                            : `${localimgpath?.talentBanner}/${talentData?.banner}?v=${Date.now()}`
                        }
                        className="w-full max-w-2xl h-56 object-cover rounded-xl"
                        alt={talentData?.real_name}
                      />

                    </div>
                  )}
                  
                  {!selectedBannerImage && !talentData?.banner && (
                    <Text
                      text={"No Banner Image"}
                      color="text-secondary"
                      size={fontSizes.h20}
                      isCenter={true}
                      isTruncate={false}
                      weight={TextWeight.Onest_regular}
                    />
                  )}
                </div>

                {/* === GALLERY IMAGES SECTION === */}
                <div className="mb-6">
                  <FileUpload
                    text={`Select Gallery Images - Max 10 images, 2MB each (${talentData?.galleries?.length ?? 0}/10 selected)`} 
                    className={"mb-4"}
                    handleChange={handleGalleryImagesSelect}
                    loading={loading.GalleryImage}
                    multiple={true}
                  />

                  {/* Uploaded count & approval message */}
                  {talentData && (
                    <p className="text-gray-300 text-sm mb-4 text-[#fff]">
                      You have{" "}
                      <span className="text-[#D4AF37] font-semibold">
                        {submittedCount.approved}
                      </span>{" "}
                      approved out of{" "}
                      <span className="text-[#D4AF37] font-semibold">
                        {submittedCount.total}
                      </span>{" "}
                      uploaded images.
                    </p>
                  )}


                  
                  {/* Preview selected images */}
                  {selectedGalleryImages.length > 0 && (
                    <div className="mb-4">
                      <p className="text-gray-400 mb-2">Selected Images ({selectedGalleryImages.length}):</p>
                      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mb-4">
                        {selectedGalleryImages.map((item, index) => (
                          <div key={index} className="relative">
                            <img
                              src={item.preview}
                              className="w-full h-40 object-cover rounded-xl"
                              alt={`Selected ${index + 1}`}
                            />
                            <button
                              onClick={() => removeSelectedGalleryImage(index)}
                              className="absolute top-2 right-2 bg-red-600 text-white rounded-full p-1.5 hover:bg-red-700"
                            >
                              <IoClose size={16} />
                            </button>
                          </div>
                        ))}
                      </div>
                      
                      {/* Update button */}
                      <button
                        onClick={handleGalleryImagesUpload}
                        disabled={loading.GalleryImage}
                        className="px-6 py-3 bg-gradient-to-r from-[#D4AF37] to-[#F4D03F] text-black font-semibold rounded-full hover:scale-105 transition-transform disabled:opacity-50"
                      >
                        {loading.GalleryImage ? "Uploading..." : `Upload ${selectedGalleryImages.length} Image(s)`}
                      </button>
                    </div>
                  )}
                  
                  {/* Current gallery images */}
                  {galleryImages?.length > 0 && (
                    <div className="mb-4">
                      <p className="text-gray-400 mb-2 text-[#fff]">Current Gallery ({galleryImages.length} images):</p>
                      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 sm:gap-3 xl:gap-4">
                        {galleryImages.map((Item, index) => (
                          <div key={index} className="relative group">
                            <img
                              onClick={() => openGallery(index)}
                              src={Item.original}
                              className="w-full h-56 object-cover rounded-xl cursor-pointer hover:opacity-80 transition-opacity"
                              alt={Item.originalAlt}
                            />
                            <button
                              onClick={() => handleDeleteGalleryImage(Item.id)}
                              className="absolute top-2 right-2 bg-red-600 text-white rounded-full p-2 opacity-0 group-hover:opacity-100 transition-opacity"
                            >
                              ✕
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  
                  {selectedGalleryImages.length === 0 && galleryImages?.length < 1 && (
                    <Text
                      text={"No Gallery Images"}
                      color="text-secondary"
                      size={fontSizes.h20}
                      isCenter={true}
                      isTruncate={false}
                      weight={TextWeight.Onest_regular}
                    />
                  )}
                </div>

                {/* === PROJECTS SECTION === */}
                <FileUpload
                  text={"Add Your Project"}
                  className={"my-4"}
                  onClick={() => navigate("/talent-add-projects")}
                  loading={loading.Project}
                />
                <div className="mb-4">
                  {talentData?.dramas?.length < 1 ? (
                    <Text
                      text={"No Project"}
                      color="text-secondary"
                      size={fontSizes.h20}
                      isCenter={true}
                      isTruncate={false}
                      weight={TextWeight.Onest_regular}
                    />
                  ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 sm:gap-3 xl:gap-4">
                      {talentData?.dramas?.map((Item, index) => (
                        <img
                          key={index}
                          src={`${localimgpath?.talentDrama}/${Item?.image}`}
                          className="w-full h-56 object-cover rounded-xl"
                          alt={talentData?.real_name}
                        />
                      ))}
                    </div>
                  )}
                </div>

                {/* === VIDEOS SECTION === */}
                <FileUpload
                  text={"Add Your Videos"}
                  className={"my-4"}
                  onClick={() => navigate("/talent-add-videos")}
                  loading={loading.Project}
                />
                <div className="mb-4">
                  {talentData?.videos?.length < 1 ? (
                    <Text
                      text={"No Videos"}
                      color="text-secondary"
                      size={fontSizes.h20}
                      isCenter={true}
                      isTruncate={false}
                      weight={TextWeight.Onest_regular}
                    />
                  ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 sm:gap-3 xl:gap-4">
                      {talentData?.videos?.map((Item, index) => (
                        <img
                          key={index}
                          src={`${localimgpath?.talentVideo}/${Item?.image}`}
                          className="w-full h-56 object-cover rounded-xl"
                          alt={talentData?.real_name}
                        />
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* === IMAGE GALLERY MODAL === */}
      <Modal
        isOpen={isOpen}
        onRequestClose={closeGallery}
        contentLabel="Image Gallery Modal"
        className="w-full mx-0 sm:mx-auto p-4 sm:p-6 bg-primary rounded-lg shadow-xl overflow-y-auto"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      >
        <button
          onClick={closeGallery}
          className="absolute top-2 right-2 text-white text-xl z-10 bg-black bg-opacity-50 rounded-full p-2 hover:bg-opacity-70"
        >
          ✕
        </button>
        {galleryImages && galleryImages.length > 0 && (
          <ImageGallery
            items={galleryImages}
            startIndex={selectedIndex}
            showPlayButton={false}
            showFullscreenButton={true}
            showThumbnails={true}
            showIndex={true}
          />
        )}
      </Modal>

      {/* === IMAGE CROPPER MODAL (Only for Hero and Banner) === */}
      <Modal
        isOpen={cropperOpen}
        onRequestClose={handleCropCancel}
        contentLabel="Image Cropper"
        className="w-full max-w-3xl mx-auto bg-[#1A1A1A] rounded-lg shadow-xl overflow-hidden"
        overlayClassName="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
      >
        <div className="relative">
          {/* Header */}
          <div className="bg-[#212121] px-6 py-4 border-b border-gray-700 flex justify-between items-center">
            <h2 className="text-white text-xl font-semibold">
              {getCropperTitle()}
            </h2>
            <button
              onClick={handleCropCancel}
              className="text-gray-400 hover:text-white transition-colors"
            >
              <IoClose size={24} />
            </button>
          </div>

          {/* Cropper */}
          <div className="relative w-full h-96 bg-black">
            <Cropper
              image={imageToCrop}
              crop={crop}
              zoom={zoom}
              aspect={getCropperAspectRatio()}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
            />
          </div>

          {/* Controls */}
          <div className="bg-[#212121] px-6 py-4 space-y-4">
            <div>
              <label className="text-white text-sm mb-2 block">Zoom</label>
              <input
                type="range"
                min={1}
                max={3}
                step={0.1}
                value={zoom}
                onChange={(e) => setZoom(e.target.value)}
                className="w-full accent-[#D4AF37]"
              />
            </div>

            {/* Buttons */}
            <div className="flex justify-end gap-4">
              <button
                onClick={handleCropCancel}
                className="px-6 py-2 bg-gray-600 text-white rounded-full hover:bg-gray-700 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleCropSave}
                className="px-6 py-2 bg-gradient-to-r from-[#D4AF37] to-[#F4D03F] text-black font-semibold rounded-full hover:scale-105 transition-transform"
              >
                Apply Crop
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}